import React, {Component} from 'react';
import {Icon} from "in-touch-icons";
import Anchor from "../objects/Anchor";

class SideBarHighlight extends Component {
    render() {
    const {
        videoThumbnail,
        videoTitle,
        featurelinkThumbnail,
        sideBarHighlight,
        featurelinkUrl,
        featurelinkText,
        advertHighlightThumbnail,
        advertHighlightText,
        advertHighlightUrl
    } = this.props

    if (sideBarHighlight === 'Featured video') {
        return (
            <div className="sidebar-highlight">
                <button className="highlight-video" onClick={() => this.props.openModal()}>
                    <div className="image" style ={ { backgroundImage: `url(${videoThumbnail})` } }></div>
                    <span className="link-feature-label">feature</span>
                    <Icon iconName='play' />
                    <span className="link-text">{videoTitle}</span>
                </button>
            </div>
        );
    } else if (sideBarHighlight === 'Featured content') {
        return (
            <div className="sidebar-highlight">
                <Anchor internal path={featurelinkUrl} anchorClass={'highlight-link'}>
                    <div className="image" style ={ { backgroundImage: `url(${featurelinkThumbnail})` } }></div>
                    <span className="link-feature-label">feature</span>
                    <span className="link-text">{featurelinkText}</span>
                </Anchor>
            </div>
        );
    } else if (sideBarHighlight === 'Featured external link') {
        return (
            <div className="sidebar-highlight">
                <a href={advertHighlightUrl} className={'highlight-link with-ad'} target="_blank">
                    <div className="image" style ={ { backgroundImage: `url(${advertHighlightThumbnail})` } }></div>
                    <span className="link-text">{advertHighlightText}</span>
                </a>
            </div>
        );
    } else {
        return (
            <div className="sidebar-highlight">
                    <div className="image" style ={ { backgroundImage: 'url(/images/bg-events-manchester.jpg)' } }></div>
            </div>
        );
    }
}
};

export default SideBarHighlight;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/SideBarHighlight.js